export class EntityListTrackers {
  static readonly TRACKER_ENTITY_LIST_REFRESH_CLICK = '[Entity List] refresh click';

  static readonly TRACKER_ENTITY_LIST_RETRY_API_CLICK = '[Entity List] retry api click';

  static readonly TRACKER_ENTITY_LIST_SEARCH = '[Entity List] search';
}
